/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswindow7d1Inputs */

const en_statswindow7d1 = /** @type {(inputs: Statswindow7d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

const de_statswindow7d1 = /** @type {(inputs: Statswindow7d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 7 Tage`)
};

/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Statswindow7d1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswindow7d1 = /** @type {((inputs?: Statswindow7d1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswindow7d1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswindow7d1(inputs)
	return de_statswindow7d1(inputs)
});
export { statswindow7d1 as "statsWindow7d" }